import { classNames, Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

import { NWIcon, type IconName } from "../nw-icon";

export type Props = {
  type: "error" | "success" | "review" | "neutral";
  iconClass?: string;
};

@tag("nw-banner")
export class NWBanner extends Component<Props> {
  static css = [tailwind];

  static propTypes = {
    type: String,
    iconClass: String,
  };

  private getIconName(type: Props["type"]): IconName {
    switch (type) {
      case "review":
        return "flip-backwards-orange";

      case "success":
        return "check-circle-outline-green";

      case "neutral":
        return "flip-backwards";

      case "error":
      default:
        return "alert-circle";
    }
  }

  render({ type, iconClass }: Props) {
    return (
      <div
        class={classNames("flex items-start rounded-xl py-4 px-6 text-primary shadow-xs", {
          "bg-error-50": type === "error",
          "bg-success-50": type === "success",
          "bg-warning-50": type === "review",
          "bg-gray-50": type === "neutral",
        })}
      >
        <NWIcon name={this.getIconName(type)} class={classNames("mr-3", iconClass)} width={24} height={24}></NWIcon>
        <slot class="inline-block"></slot>
      </div>
    );
  }
}
